import { render, staticRenderFns } from "./registration.vue?vue&type=template&id=a7b532e4&scoped=true"
import script from "./registration.vue?vue&type=script&lang=ts"
export * from "./registration.vue?vue&type=script&lang=ts"
import style0 from "./registration.vue?vue&type=style&index=0&id=a7b532e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b532e4",
  null
  
)

export default component.exports